import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  createStyles,
  Theme,
  makeStyles,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem, { ListItemProps } from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import PhotoIcon from "@material-ui/icons/Photo";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import { displayAlertifyError } from "../../util/functions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      margin: 0,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "25ch",
    },
    divider: {
      // Theme Color, or use css color in quote
      background: "#000",
    },
    input: {
      display: "none",
    },
  })
);

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

function ListItemLink(props: ListItemProps<"a", { button?: true }>) {
  return <ListItem button component="a" {...props} />;
}

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function WebAndLink() {
  const classes = useStyles();
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");

  const [host, setHost] = useState(APIModel.HOST);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [items, setItems] = useState([]);
  const [company, setCompany] = useState([]);
  const [taxes, setTaxes] = useState([]);

  const [id, setId] = useState("");
  const [facebook_url, setFacebookUrl] = useState("");
  const [instagram_url, setInstagramUrl] = useState("");
  const [twitter_url, setTwitterUrl] = useState("");
  const [web_url, setWebUrl] = useState("");
  const [count, setCount] = useState(0);
  const [selectedFile, setSelectedFile] = useState();
  const [selectedFileName, setSelectedFileName] = useState();
  const [profile, setProfile] = useState("");
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [search, setSearch] = useState("");
  const [foundItems, setFoundItems] = useState(items);
  const [noResult, setNoResult] = useState(false);

  const [taxInfo, setTaxInfo] = useState([]);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  // const changeHandler = (event) => {
  // 	setSelectedFile(event.target.files[0]);
  // };

  const handleselectedFile = (event) => {
    setSelectedFile(event.target.files[0]);
    setSelectedFileName(event.target.files[0].name);
  };

  const handleSelect = (event) => {
    setProfile(event.target.value);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(host + "get-license-web-links", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        if (response.data.data == null) {
          setCompany("");
        } else {
          setId(response.data.data.id);
          setCompany(response.data.data);
          console.log(id);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [count, host, id, token]);

  function updateProfile() {
    let facebookUrl = $("#facebook_url").val();
    setFacebookUrl(facebookUrl);
    let twitterUrl = $("#twitter_url").val();
    setTwitterUrl(twitterUrl);
    let instagramUrl = $("#instagram_url").val();
    setInstagramUrl(instagramUrl);
    let webUrl = $("#web_url").val();
    setWebUrl(webUrl);

    /*if (facebookUrl === "" || facebookUrl === undefined) {
      displayAlertifyError({ error: "Please enter facebook Url" });
      return false;
    }
    if (twitterUrl === "" || twitterUrl === undefined) {
      displayAlertifyError({ error: "Please enter twitter Url" });
      return false;
    }
    if (instagramUrl === "" || instagramUrl === undefined) {
      displayAlertifyError({ error: "Please enter instagram Url" });
      return false;
    }
    if (webUrl === "" || webUrl === undefined) {
      displayAlertifyError({ error: "Please enter web Url" });
      return false;
    }*/

    const fd = new FormData();
    if (selectedFile != null) {
      fd.append("file_url", selectedFile, selectedFile.name);
    }
    fd.append("id", id);
    fd.append("facebook_url", facebookUrl);
    fd.append("twitter_url", twitterUrl);
    fd.append("instagram_url", instagramUrl);
    fd.append("web_url", webUrl);

    return axios
      .post(host + "update-license", fd, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch((response) => {
        console.log(response);
      });
  }

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-primary pull-right mr-2"
                      onClick={() => {
                        updateProfile();
                      }}
                    >
                      Update
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="text-center pb-3">
                          <h3 style={{ fontWeight: "bold", marginTop: "10px" }}>
                            {" "}
                            Web and Social Links
                          </h3>
                        </div>
                        <form id="create_client">
                          <div className="row">
                            {/* <Box
                              fontSize={20}
                              fontWeight="fontWeightRegular"
                              ml={2}
                              mb={2}
                            >
                              Web and Social Links
                            </Box> */}
                            <div className="col-12 col-md-6">
                              <div className="form-group mb-1">
                                <label className="mdc-floating-label--shake mb-1">
                                  Facebook Link
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-box"
                                  id="facebook_url"
                                  name="facebook_url"
                                  required="required"
                                  autoFocus
                                  defaultValue={company.facebook_url}
                                  onChange={(e) =>
                                    setFacebookUrl(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-12 col-md-6">
                              <div className="form-group mb-1">
                                <label className="mdc-floating-label--shake mb-1">
                                  Twitter Link
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-box"
                                  id="twitter_url"
                                  name="twitter_url"
                                  required="required"
                                  defaultValue={company.twitter_url}
                                  onChange={(e) =>
                                    setTwitterUrl(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-12 col-md-6">
                              <div className="form-group mb-1">
                                <label className="mdc-floating-label--shake mb-1">
                                  Instagram Link
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-box"
                                  id="instagram_url"
                                  name="instagram_url"
                                  required
                                  defaultValue={company.instagram_url}
                                  onChange={(e) =>
                                    setInstagramUrl(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-12 col-md-6">
                              <div className="form-group mb-1">
                                <label className="mdc-floating-label--shake mb-1">
                                  Website
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-box"
                                  id="web_url"
                                  name="web_url"
                                  required
                                  defaultValue={company.web_url}
                                  onChange={(e) => setWebUrl(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <b>{selectedFileName}</b>
                              <Box m={2} ml={0}>
                                <input
                                  accept="image/*"
                                  className={classes.input}
                                  id="contained-button-file"
                                  type="file"
                                  name="file"
                                  onChange={handleselectedFile}
                                />
                                <label htmlFor="contained-button-file">
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    style={{ borderRadius: 50 }}
                                  >
                                    Upload License Image
                                    <CloudUploadIcon className="ml-2" />
                                  </Button>
                                </label>
                              </Box>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <div className="form-group">
                                {company.file_url !== null ? (
                                  <img
                                    src={company.file_url}
                                    alt="License"
                                    width={250}
                                    height={200}
                                  />
                                ) : (
                                  <Typography variant="body1">
                                    No image{" "}
                                  </Typography>
                                )}
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default WebAndLink;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;
